/**
 * P2.2: Estado de red (Capacitor Network + navigator.onLine).
 * Usado por OfflineContext y sync.
 */
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';

let currentOnlineStatus = true;

if (typeof navigator !== 'undefined') {
  currentOnlineStatus = navigator.onLine;
}

// Override para tests E2E (Playwright)
function getIsOnline(): boolean {
  if (typeof window !== 'undefined' && (window as any).__TEST_FORCE_OFFLINE__ === true) {
    return false;
  }
  return currentOnlineStatus;
}

export type NetworkStatusListener = (isOnline: boolean) => void;
const listeners = new Set<NetworkStatusListener>();

function notify(online: boolean) {
  currentOnlineStatus = online;
  const status = getIsOnline();
  listeners.forEach((cb) => cb(status));
}

// Suscripción al hardware nativo si estamos en dispositivo móvil
if (Capacitor.isNativePlatform()) {
  Network.getStatus()
    .then((status) => {
      notify(status.connected);
    })
    .catch((err) => {
      console.warn('[Network] Failed to get initial status:', err);
    });

  Network.addListener('networkStatusChange', (status) => {
    notify(status.connected);
  });
} else if (typeof window !== 'undefined') {
  window.addEventListener('online', () => notify(true));
  window.addEventListener('offline', () => notify(false));
}

export function subscribeToNetworkStatus(callback: NetworkStatusListener): () => void {
  callback(getIsOnline());
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function getNetworkStatus(): boolean {
  return getIsOnline();
}
